var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "section operations" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.cooperateEdit,
                expression: "cooperateEdit"
              }
            ],
            staticClass: "triggers"
          },
          [
            _c(
              "div",
              [
                _c(
                  "el-dropdown",
                  {
                    class: _vm.readonly ? "not-click" : "",
                    attrs: { no: "1", "split-button": "", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.commandHandle(_vm.command1)
                      },
                      command: function(p) {
                        _vm.command1 = p
                        _vm.commandHandle(_vm.command1)
                      }
                    }
                  },
                  [
                    _vm._v(" " + _vm._s(_vm.command1) + " "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: _vm.$t("SeaExport.CodeSearching")
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                        ),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: _vm.$t("SeaExport.CopyFromTheLastTime")
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.CopyFromTheLastTime"))
                            )
                          ]
                        ),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: _vm.$t("SeaExport.CopyFromOtherBill")
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.CopyFromOtherBill"))
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-dropdown",
                  {
                    class: _vm.btnBLConfirmDisabled ? "not-click" : "",
                    staticStyle: { "padding-left": "5px" },
                    attrs: { no: "2", "split-button": "", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.commandHandle(_vm.command2)
                      },
                      command: function(p) {
                        _vm.command2 = p
                        _vm.commandHandle(_vm.command2)
                      }
                    }
                  },
                  [
                    _vm._v(" " + _vm._s(_vm.command2) + " "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: _vm.$t("SeaExport.InviteToChecktheBL")
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.InviteToChecktheBL")) +
                                " "
                            )
                          ]
                        ),
                        _vm.$checkPermission(["button_M/HBL_identification"])
                          ? _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t(
                                    "SeaExport.IdentificationList"
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.IdentificationList"))
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: _vm.$t("SeaExport.CheckingHistory")
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.CheckingHistory")) + " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "10px" },
                    attrs: { no: "3", disabled: _vm.readonly },
                    model: {
                      value: _vm.form.edi,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "edi", $$v)
                      },
                      expression: "form.edi"
                    }
                  },
                  [_vm._v("EDI")]
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "-20px" },
                    attrs: { no: "4", disabled: _vm.readonly },
                    model: {
                      value: _vm.form.oversea,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "oversea", $$v)
                      },
                      expression: "form.oversea"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.BlBeReleased")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "-20px" },
                    attrs: { no: "5", disabled: _vm.readonly },
                    on: {
                      change: function($event) {
                        return _vm.pm.chargeEsaeq()
                      }
                    },
                    model: {
                      value: _vm.form.printParam1,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "printParam1", $$v)
                      },
                      expression: "form.printParam1"
                    }
                  },
                  [_vm._v("Part of")]
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "-20px" },
                    attrs: { no: "6", disabled: _vm.readonly },
                    on: {
                      change: function($event) {
                        return _vm.pm.changeContainer()
                      }
                    },
                    model: {
                      value: _vm.form.printParam3,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "printParam3", $$v)
                      },
                      expression: "form.printParam3"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "SeaExport.ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS"
                        )
                      )
                    )
                  ]
                )
              ],
              1
            )
          ]
        )
      ]),
      _c(
        "tab-MBL2-UICustom-layout",
        { attrs: { "element-blocks": _vm.elementBlocks } },
        [
          !_vm.form.showDetail
            ? [
                _c(
                  "el-form-item",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "flex-end",
                      "margin-top": "-24px"
                    },
                    attrs: { slot: "detailFormat" },
                    slot: "detailFormat"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          no: "DetailFormat",
                          disabled: _vm.readonly,
                          type: "primary"
                        },
                        on: {
                          click: function($event) {
                            return _vm.formatChange(true)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_DetailFormat")) + " "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "155px" },
                    attrs: {
                      no: "DetailFormat",
                      disabled: _vm.readonly,
                      type: "primary"
                    },
                    on: {
                      click: function($event) {
                        return _vm.formatChange(true)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DetailFormat")) + " ")]
                ),
                _vm.elementDict.shipper.viewable
                  ? _c(
                      "template",
                      { slot: "shipper" },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            class: _vm.variableCss.shipperCode,
                            attrs: { label: _vm.$t("SeaExport.Shipper") }
                          },
                          [
                            _c(
                              "template",
                              { slot: "label" },
                              [
                                _c("line-label", {
                                  class:
                                    (_vm.elementDict.shipper.isRequire
                                      ? "blue "
                                      : " ") + _vm.variableCss.shipperLine,
                                  attrs: {
                                    label: _vm.elementDict.shipper.label
                                  }
                                }),
                                _c("char-count", {
                                  staticStyle: {
                                    position: "static",
                                    display: "block",
                                    "font-size": "10px",
                                    color: "#909399"
                                  },
                                  attrs: { form: _vm.form, prefix: "shipper" }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: { display: "flex", width: "100%" }
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                      expression:
                                        "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                    }
                                  ],
                                  ref: "shipperCode",
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.shipper.writable,
                                    no: "7"
                                  },
                                  model: {
                                    value: _vm.form.shipperCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "shipperCode", $$v)
                                    },
                                    expression: "form.shipperCode"
                                  }
                                }),
                                _c("cargo-advance-select", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                      expression:
                                        "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                    }
                                  ],
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.shipper.writable,
                                    no: "8",
                                    "select-type":
                                      _vm.selectTypeNames.basic_data_Company,
                                    "method-params": {
                                      shipper: true,
                                      active: true
                                    },
                                    filterable: "",
                                    "default-value": _vm.form.shipperId || ""
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.pm.shipperAutoCompleteChange(p)
                                    }
                                  }
                                }),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      no: "9",
                                      type: "primary",
                                      disabled:
                                        _vm.readonly ||
                                        !_vm.elementDict.shipper.writable
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.onClear(1)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                                )
                              ],
                              1
                            )
                          ],
                          2
                        ),
                        _vm._l(7, function(count) {
                          return _c(
                            "el-form-item",
                            {
                              key: "shipperLine" + count,
                              class:
                                "auto-width " +
                                _vm.getClass("shipperLine", count)
                            },
                            [
                              _c("cargo-input", {
                                ref: "shipperLine" + count,
                                refInFor: true,
                                attrs: {
                                  disabled:
                                    _vm.readonly ||
                                    !_vm.elementDict.shipper.writable,
                                  no: "shipperLine" + count,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                on: {
                                  change: function() {
                                    return _vm.wrapAddr(
                                      _vm.form,
                                      "shipperLine" + count,
                                      count + 1 > 6
                                        ? null
                                        : "shipperLine" + (count + 1),
                                      _vm.maxChars
                                    )
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showShipperDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form["shipperLine" + count],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "shipperLine" + count,
                                      $$v
                                    )
                                  },
                                  expression: "form['shipperLine'+count]"
                                }
                              })
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.elementDict.consignee.viewable
                  ? _c(
                      "template",
                      { slot: "consignee" },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            class: _vm.variableCss.consigneeCode,
                            attrs: { label: _vm.$t("SeaExport.Consignee") }
                          },
                          [
                            _c(
                              "template",
                              { slot: "label" },
                              [
                                _c("line-label", {
                                  class:
                                    (_vm.elementDict.consignee.isRequire
                                      ? "blue"
                                      : "") + _vm.variableCss.consigneeLine,
                                  attrs: {
                                    label: _vm.elementDict.consignee.label
                                  }
                                }),
                                _c("char-count", {
                                  staticStyle: {
                                    position: "static",
                                    display: "block",
                                    "font-size": "10px",
                                    color: "#909399"
                                  },
                                  attrs: { form: _vm.form, prefix: "consignee" }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                      expression:
                                        "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                    }
                                  ],
                                  ref: "consigneeCode",
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.consignee.writable,
                                    no: "10"
                                  },
                                  model: {
                                    value: _vm.form.consigneeCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "consigneeCode", $$v)
                                    },
                                    expression: "form.consigneeCode"
                                  }
                                }),
                                _c("cargo-advance-select", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                      expression:
                                        "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                    }
                                  ],
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.consignee.writable,
                                    no: "11",
                                    "select-type":
                                      _vm.selectTypeNames.basic_data_Company,
                                    "method-params": {
                                      consignee: true,
                                      active: true
                                    },
                                    filterable: "",
                                    "default-value": _vm.form.consigneeId || ""
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.pm.consigneeAutoCompleteChange(p)
                                    }
                                  }
                                }),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      no: "12",
                                      type: "primary",
                                      disabled:
                                        _vm.readonly ||
                                        !_vm.elementDict.consignee.writable
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.onClear(2)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                                )
                              ],
                              1
                            )
                          ],
                          2
                        ),
                        _vm._l(7, function(count) {
                          return _c(
                            "el-form-item",
                            {
                              key: "consigneeLine" + count,
                              class:
                                "auto-width " +
                                _vm.getClass("consigneeLine", count)
                            },
                            [
                              _c("cargo-input", {
                                ref: "consigneeLine" + count,
                                refInFor: true,
                                attrs: {
                                  disabled:
                                    _vm.readonly ||
                                    !_vm.elementDict.consignee.writable,
                                  no: "consigneeLine" + count,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                on: {
                                  change: function() {
                                    return _vm.wrapAddr(
                                      _vm.form,
                                      "consigneeLine" + count,
                                      count + 1 > 6
                                        ? null
                                        : "consigneeLine" + (count + 1),
                                      _vm.maxChars
                                    )
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showConsigneeDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form["consigneeLine" + count],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "consigneeLine" + count,
                                      $$v
                                    )
                                  },
                                  expression: "form['consigneeLine'+count]"
                                }
                              })
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.elementDict.notify.viewable
                  ? _c(
                      "template",
                      { slot: "notify" },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            class: _vm.variableCss.notifyCode,
                            attrs: { label: _vm.$t("SeaExport.NotifyParty") }
                          },
                          [
                            _c(
                              "template",
                              { slot: "label" },
                              [
                                _c("line-label", {
                                  class:
                                    (_vm.elementDict.notify.isRequire
                                      ? "blue "
                                      : " ") + _vm.variableCss.notifyLine,
                                  attrs: { label: _vm.elementDict.notify.label }
                                }),
                                _c("char-count", {
                                  staticStyle: {
                                    position: "static",
                                    display: "block",
                                    "font-size": "10px",
                                    color: "#909399"
                                  },
                                  attrs: { form: _vm.form, prefix: "notify" }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                      expression:
                                        "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                    }
                                  ],
                                  ref: "notifyCode",
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.notify.writable,
                                    no: "13"
                                  },
                                  model: {
                                    value: _vm.form.notifyCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "notifyCode", $$v)
                                    },
                                    expression: "form.notifyCode"
                                  }
                                }),
                                _c("cargo-advance-select", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                      expression:
                                        "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                    }
                                  ],
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.notify.writable,
                                    no: "14",
                                    "select-type":
                                      _vm.selectTypeNames.basic_data_Company,
                                    "method-params": {
                                      notify: true,
                                      active: true
                                    },
                                    filterable: "",
                                    "default-value": _vm.form.notifyId || ""
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.pm.notifyAutoCompleteChange(p)
                                    }
                                  }
                                }),
                                _c(
                                  "div",
                                  { staticStyle: { "margin-top": "5px" } },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "15",
                                          type: "primary",
                                          disabled:
                                            _vm.readonly ||
                                            !_vm.elementDict.notify.writable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.pm.onClear(3)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.Reset"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { "margin-left": "5px" },
                                        attrs: {
                                          no: "16",
                                          type: "primary",
                                          disabled:
                                            _vm.readonly ||
                                            !_vm.elementDict.notify.writable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.pm.onCopyConsignee()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.CopyTheConsignee")
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          2
                        ),
                        _vm._l(7, function(count) {
                          return _c(
                            "el-form-item",
                            {
                              key: "notifyLine" + count,
                              class:
                                "auto-width " +
                                _vm.getClass("notifyLine", count)
                            },
                            [
                              _c("cargo-input", {
                                ref: "notifyLine" + count,
                                refInFor: true,
                                attrs: {
                                  disabled:
                                    _vm.readonly ||
                                    !_vm.elementDict.notify.writable,
                                  no: "notifyLine" + count,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                on: {
                                  change: function() {
                                    return _vm.wrapAddr(
                                      _vm.form,
                                      "notifyLine" + count,
                                      count + 1 > 6
                                        ? null
                                        : "notifyLine" + (count + 1),
                                      _vm.maxChars
                                    )
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showNotifyDialog($event)
                                  }
                                },
                                model: {
                                  value: _vm.form["notifyLine" + count],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "notifyLine" + count,
                                      $$v
                                    )
                                  },
                                  expression: "form['notifyLine'+count]"
                                }
                              })
                            ],
                            1
                          )
                        }),
                        _c("el-form-item", {
                          staticClass: " auto-width",
                          attrs: { label: "ALSO NOTIFY" }
                        }),
                        _c(
                          "el-form-item",
                          { staticClass: " auto-width" },
                          [
                            _c("cargo-rich-textarea", {
                              staticStyle: { height: "110px" },
                              attrs: {
                                no: "17",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.notify.writable,
                                "wrap-symbol": "r",
                                "text-chars": 0,
                                "auto-half-word": "",
                                "auto-uppercase": ""
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showAdvanceTextDialog(
                                    "ALSO NOTIFY",
                                    _vm.form.alsoNotify,
                                    function(val) {
                                      _vm.form.alsoNotify = val
                                    },
                                    _vm.notUppercaseShipperConsigneNotify,
                                    {
                                      warningCount: 45,
                                      maxChar: 0,
                                      autoUppercase: true,
                                      autoHalfWord: true
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.form.alsoNotify,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "alsoNotify", $$v)
                                },
                                expression: "form.alsoNotify"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.elementDict.payment.viewable
                  ? _c(
                      "template",
                      { slot: "payment" },
                      [
                        _vm.job.paymentTermMBL === "3P"
                          ? _c(
                              "el-form-item",
                              {
                                staticClass: "auto-width",
                                staticStyle: { "padding-top": "5px" }
                              },
                              [
                                _c("line-label", {
                                  class: _vm.elementDict.payment.isRequire
                                    ? "blue"
                                    : "",
                                  attrs: {
                                    slot: "label",
                                    label: _vm.elementDict.payment.label
                                  },
                                  slot: "label"
                                }),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      width: "100%"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { flex: "1" },
                                      attrs: {
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.payment.writable,
                                        no: "paymentCode"
                                      },
                                      model: {
                                        value: _vm.form.paymentCode,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "paymentCode", $$v)
                                        },
                                        expression: "form.paymentCode"
                                      }
                                    }),
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { "margin-left": "5px" },
                                        attrs: {
                                          no: "BringInDat",
                                          type: "primary",
                                          disabled:
                                            _vm.readonly ||
                                            !_vm.elementDict.payment.writable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.pm.paymentImportData(
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("CargoMsg.Cargo_BringInData")
                                          ) + " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._l(7, function(count) {
                          return _vm.job.paymentTermMBL === "3P"
                            ? _c(
                                "el-form-item",
                                {
                                  key: "paymentLine" + count,
                                  staticClass: "auto-width"
                                },
                                [
                                  _c("cargo-input", {
                                    ref: "paymentLine" + count,
                                    refInFor: true,
                                    attrs: {
                                      disabled:
                                        _vm.readonly ||
                                        !_vm.elementDict.payment.writable,
                                      no: "paymentLine" + count,
                                      "auto-uppercase": _vm.isUppercase,
                                      "filter-chars": false,
                                      "use-read-only": true
                                    },
                                    on: {
                                      change: function() {
                                        return _vm.wrapAddr(
                                          _vm.form,
                                          "paymentLine" + count,
                                          count + 1 > 6
                                            ? null
                                            : "paymentLine" + (count + 1),
                                          0
                                        )
                                      }
                                    },
                                    nativeOn: {
                                      dblclick: function($event) {
                                        return _vm.showPaymentDialog($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.form["paymentLine" + count],
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "paymentLine" + count,
                                          $$v
                                        )
                                      },
                                      expression: "form['paymentLine'+count]"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ]
            : _vm._e(),
          _vm.form.showDetail
            ? [
                _c(
                  "el-form-item",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "flex-end",
                      "margin-top": "-24px"
                    },
                    attrs: { slot: "detailFormat" },
                    slot: "detailFormat"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          no: "GeneralFormat",
                          disabled: _vm.readonly,
                          type: "primary"
                        },
                        on: {
                          click: function($event) {
                            return _vm.formatChange(false)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_GeneralFormat")) + " "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm.elementDict.shipper.viewable
                  ? _c(
                      "template",
                      { slot: "shipper" },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            class: _vm.variableCss.shipperCode
                          },
                          [
                            _c(
                              "template",
                              { slot: "label" },
                              [
                                _c("line-label", {
                                  class:
                                    (_vm.elementDict.shipper.isRequire
                                      ? "blue "
                                      : " ") + _vm.variableCss.shipperLine,
                                  attrs: {
                                    label: _vm.elementDict.shipper.label
                                  }
                                }),
                                _c("char-count", {
                                  staticStyle: {
                                    position: "static",
                                    display: "block",
                                    "font-size": "10px",
                                    color: "#909399"
                                  },
                                  attrs: { form: _vm.form, prefix: "shipper" }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: { display: "flex", width: "100%" }
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                      expression:
                                        "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                    }
                                  ],
                                  ref: "shipperCode",
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.shipper.writable,
                                    no: "7"
                                  },
                                  model: {
                                    value: _vm.form.shipperCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "shipperCode", $$v)
                                    },
                                    expression: "form.shipperCode"
                                  }
                                }),
                                _c("cargo-advance-select", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                      expression:
                                        "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                    }
                                  ],
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.shipper.writable,
                                    no: "8",
                                    "select-type":
                                      _vm.selectTypeNames.basic_data_Company,
                                    "method-params": {
                                      shipper: true,
                                      active: true
                                    },
                                    filterable: "",
                                    "default-value": _vm.form.shipperId || ""
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.pm.shipperAutoCompleteChange(p, true)
                                    }
                                  }
                                }),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      no: "9",
                                      type: "primary",
                                      disabled:
                                        _vm.readonly ||
                                        !_vm.elementDict.shipper.writable
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.onClear(1, true)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                                )
                              ],
                              1
                            )
                          ],
                          2
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Name") }
                          },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "shipperLine1",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.shipper.writable,
                                "filter-chars": false,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "shipperLine1",
                                    "shipperLine2",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showShipperDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.shipperLine1,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipperLine1", $$v)
                                },
                                expression: "form.shipperLine1"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("SeaExport.Addr") + "1" }
                          },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "shipperLine2",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.shipper.writable,
                                "filter-chars": false,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "shipperLine2",
                                    "shipperLine3",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showShipperDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.shipperLine2,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipperLine2", $$v)
                                },
                                expression: "form.shipperLine2"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("SeaExport.Addr") + "2" }
                          },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "shipperLine3",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.shipper.writable,
                                "filter-chars": false,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "shipperLine3",
                                    "shipperLine4",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showShipperDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.shipperLine3,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipperLine3", $$v)
                                },
                                expression: "form.shipperLine3"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-bottom": "-10px" },
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Country") }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    no: "shipperCountry",
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.shipper.writable
                                  },
                                  model: {
                                    value: _vm.form.shipperCountry,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "shipperCountry", $$v)
                                    },
                                    expression: "form.shipperCountry"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_CityP"),
                                      "label-width": "70px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        no: "shipperCity",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.shipper.writable
                                      },
                                      model: {
                                        value: _vm.form.shipperCity,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "shipperCity", $$v)
                                        },
                                        expression: "form.shipperCity"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Province1") }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    no: "shipperProvince",
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.shipper.writable
                                  },
                                  model: {
                                    value: _vm.form.shipperProvince,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "shipperProvince", $$v)
                                    },
                                    expression: "form.shipperProvince"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_PostalCode"
                                      ),
                                      "label-width": "70px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        no: "shipperZipCode",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.shipper.writable
                                      },
                                      model: {
                                        value: _vm.form.shipperZipCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "shipperZipCode",
                                            $$v
                                          )
                                        },
                                        expression: "form.shipperZipCode"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("CargoMsg.Cargo_Tel") } },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    no: "shipperMobile",
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.shipper.writable
                                  },
                                  model: {
                                    value: _vm.form.shipperMobile,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "shipperMobile", $$v)
                                    },
                                    expression: "form.shipperMobile"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_email"),
                                      "label-width": "70px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        no: "shipperEmail",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.shipper.writable
                                      },
                                      model: {
                                        value: _vm.form.shipperEmail,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "shipperEmail",
                                            $$v
                                          )
                                        },
                                        expression: "form.shipperEmail"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Contact") }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "padding-bottom": "5px"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    no: "shipperContact",
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.shipper.writable
                                  },
                                  model: {
                                    value: _vm.form.shipperContact,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "shipperContact", $$v)
                                    },
                                    expression: "form.shipperContact"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Fax",
                                      "label-width": "70px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        no: "shipperFax",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.shipper.writable
                                      },
                                      model: {
                                        value: _vm.form.shipperFax,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "shipperFax", $$v)
                                        },
                                        expression: "form.shipperFax"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.consignee.viewable
                  ? _c(
                      "template",
                      { slot: "consignee" },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            class: _vm.variableCss.consigneeCode
                          },
                          [
                            _c(
                              "template",
                              { slot: "label" },
                              [
                                _c("line-label", {
                                  class:
                                    (_vm.elementDict.consignee.isRequire
                                      ? "blue "
                                      : " ") + _vm.variableCss.consigneeLine,
                                  attrs: {
                                    label: _vm.elementDict.consignee.label
                                  }
                                }),
                                _c("char-count", {
                                  staticStyle: {
                                    position: "static",
                                    display: "block",
                                    "font-size": "10px",
                                    color: "#909399"
                                  },
                                  attrs: { form: _vm.form, prefix: "consignee" }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                      expression:
                                        "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                    }
                                  ],
                                  ref: "consigneeCode",
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.consignee.writable,
                                    no: "10"
                                  },
                                  model: {
                                    value: _vm.form.consigneeCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "consigneeCode", $$v)
                                    },
                                    expression: "form.consigneeCode"
                                  }
                                }),
                                _c("cargo-advance-select", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                      expression:
                                        "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                    }
                                  ],
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.consignee.writable,
                                    no: "11",
                                    "select-type":
                                      _vm.selectTypeNames.basic_data_Company,
                                    "method-params": {
                                      consignee: true,
                                      active: true
                                    },
                                    filterable: "",
                                    "default-value": _vm.form.consigneeId || ""
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.pm.consigneeAutoCompleteChange(
                                        p,
                                        true
                                      )
                                    }
                                  }
                                }),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      no: "12",
                                      type: "primary",
                                      disabled:
                                        _vm.readonly ||
                                        !_vm.elementDict.consignee.writable
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.onClear(2, true)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                                )
                              ],
                              1
                            )
                          ],
                          2
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Name") }
                          },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "consigneeLine1",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.consignee.writable,
                                "filter-chars": false,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "consigneeLine1",
                                    "consigneeLine2",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showConsigneeDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.consigneeLine1,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "consigneeLine1", $$v)
                                },
                                expression: "form.consigneeLine1"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("SeaExport.Addr") + "1" }
                          },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "consigneeLine2",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.consignee.writable,
                                "filter-chars": false,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "consigneeLine2",
                                    "consigneeLine3",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showConsigneeDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.consigneeLine2,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "consigneeLine2", $$v)
                                },
                                expression: "form.consigneeLine2"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("SeaExport.Addr") + "2" }
                          },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "consigneeLine3",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.consignee.writable,
                                "filter-chars": false,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "consigneeLine3",
                                    "consigneeLine4",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showConsigneeDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.consigneeLine3,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "consigneeLine3", $$v)
                                },
                                expression: "form.consigneeLine3"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Country") }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    no: "consigneeCountry",
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.consignee.writable
                                  },
                                  model: {
                                    value: _vm.form.consigneeCountry,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "consigneeCountry",
                                        $$v
                                      )
                                    },
                                    expression: "form.consigneeCountry"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_CityP"),
                                      "label-width": "70px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        no: "consigneeCity",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.consignee.writable
                                      },
                                      model: {
                                        value: _vm.form.consigneeCity,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "consigneeCity",
                                            $$v
                                          )
                                        },
                                        expression: "form.consigneeCity"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Province1") }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    no: "consigneeProvince",
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.consignee.writable
                                  },
                                  model: {
                                    value: _vm.form.consigneeProvince,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "consigneeProvince",
                                        $$v
                                      )
                                    },
                                    expression: "form.consigneeProvince"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_PostalCode"
                                      ),
                                      "label-width": "70px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        no: "consigneeZipCode",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.consignee.writable
                                      },
                                      model: {
                                        value: _vm.form.consigneeZipCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "consigneeZipCode",
                                            $$v
                                          )
                                        },
                                        expression: "form.consigneeZipCode"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("CargoMsg.Cargo_Tel") } },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    no: "consigneeMobile",
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.consignee.writable
                                  },
                                  model: {
                                    value: _vm.form.consigneeMobile,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "consigneeMobile", $$v)
                                    },
                                    expression: "form.consigneeMobile"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_email"),
                                      "label-width": "70px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        no: "consigneeEmail",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.consignee.writable
                                      },
                                      model: {
                                        value: _vm.form.consigneeEmail,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "consigneeEmail",
                                            $$v
                                          )
                                        },
                                        expression: "form.consigneeEmail"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Contact") }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "padding-bottom": "5px"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    no: "consigneeContact",
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.consignee.writable
                                  },
                                  model: {
                                    value: _vm.form.consigneeContact,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "consigneeContact",
                                        $$v
                                      )
                                    },
                                    expression: "form.consigneeContact"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Fax",
                                      "label-width": "70px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        no: "consigneeFax",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.consignee.writable
                                      },
                                      model: {
                                        value: _vm.form.consigneeFax,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "consigneeFax",
                                            $$v
                                          )
                                        },
                                        expression: "form.consigneeFax"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.notify.viewable
                  ? _c(
                      "template",
                      { slot: "notify" },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            class: _vm.variableCss.notifyCode
                          },
                          [
                            _c(
                              "template",
                              { slot: "label" },
                              [
                                _c("line-label", {
                                  class:
                                    (_vm.elementDict.notify.isRequire
                                      ? "blue "
                                      : " ") + _vm.variableCss.notifyLine,
                                  attrs: { label: _vm.elementDict.notify.label }
                                }),
                                _c("char-count", {
                                  staticStyle: {
                                    position: "static",
                                    display: "block",
                                    "font-size": "10px",
                                    color: "#909399"
                                  },
                                  attrs: { form: _vm.form, prefix: "notify" }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                      expression:
                                        "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                    }
                                  ],
                                  ref: "notifyCode",
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.notify.writable,
                                    no: "13"
                                  },
                                  model: {
                                    value: _vm.form.notifyCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "notifyCode", $$v)
                                    },
                                    expression: "form.notifyCode"
                                  }
                                }),
                                _c("cargo-advance-select", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                      expression:
                                        "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                    }
                                  ],
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.notify.writable,
                                    no: "14",
                                    "select-type":
                                      _vm.selectTypeNames.basic_data_Company,
                                    "method-params": {
                                      notify: true,
                                      active: true
                                    },
                                    filterable: "",
                                    "default-value": _vm.form.notifyId || ""
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.pm.notifyAutoCompleteChange(p, true)
                                    }
                                  }
                                }),
                                _c(
                                  "div",
                                  { staticStyle: { "margin-top": "5px" } },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "15",
                                          type: "primary",
                                          disabled:
                                            _vm.readonly ||
                                            !_vm.elementDict.notify.writable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.pm.onClear(3, true)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.Reset"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { "margin-left": "5px" },
                                        attrs: {
                                          no: "16",
                                          type: "primary",
                                          disabled:
                                            _vm.readonly ||
                                            !_vm.elementDict.notify.writable
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.pm.onCopyConsignee(true)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.CopyTheConsignee")
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          2
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Name") }
                          },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "notifyLine1",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.notify.writable,
                                "filter-chars": false,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "notifyLine1",
                                    "notifyLine2",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showNotifyDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.notifyLine1,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "notifyLine1", $$v)
                                },
                                expression: "form.notifyLine1"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("SeaExport.Addr") + "1" }
                          },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "notifyLine2",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.notify.writable,
                                "filter-chars": false,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "notifyLine2",
                                    "notifyLine3",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showNotifyDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.notifyLine2,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "notifyLine2", $$v)
                                },
                                expression: "form.notifyLine2"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("SeaExport.Addr") + "2" }
                          },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "notifyLine3",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.notify.writable,
                                "filter-chars": false,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "notifyLine3",
                                    "notifyLine4",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showNotifyDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.notifyLine3,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "notifyLine3", $$v)
                                },
                                expression: "form.notifyLine3"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Country") }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    no: "notifyCountry",
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.notify.writable
                                  },
                                  model: {
                                    value: _vm.form.notifyCountry,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "notifyCountry", $$v)
                                    },
                                    expression: "form.notifyCountry"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_CityP"),
                                      "label-width": "70px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        no: "notifyCity",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.notify.writable
                                      },
                                      model: {
                                        value: _vm.form.notifyCity,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "notifyCity", $$v)
                                        },
                                        expression: "form.notifyCity"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Province1") }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    no: "notifyProvince",
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.notify.writable
                                  },
                                  model: {
                                    value: _vm.form.notifyProvince,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "notifyProvince", $$v)
                                    },
                                    expression: "form.notifyProvince"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_PostalCode"
                                      ),
                                      "label-width": "70px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        no: "notifyZipCode",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.notify.writable
                                      },
                                      model: {
                                        value: _vm.form.notifyZipCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "notifyZipCode",
                                            $$v
                                          )
                                        },
                                        expression: "form.notifyZipCode"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("CargoMsg.Cargo_Tel") } },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    no: "notifyMobile",
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.notify.writable
                                  },
                                  model: {
                                    value: _vm.form.notifyMobile,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "notifyMobile", $$v)
                                    },
                                    expression: "form.notifyMobile"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_email"),
                                      "label-width": "70px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        no: "notifyEmail",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.notify.writable
                                      },
                                      model: {
                                        value: _vm.form.notifyEmail,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "notifyEmail", $$v)
                                        },
                                        expression: "form.notifyEmail"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Contact") }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "padding-bottom": "5px"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    no: "notifyContact",
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.notify.writable
                                  },
                                  model: {
                                    value: _vm.form.notifyContact,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "notifyContact", $$v)
                                    },
                                    expression: "form.notifyContact"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Fax",
                                      "label-width": "70px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        no: "notifyFax",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.notify.writable
                                      },
                                      model: {
                                        value: _vm.form.notifyFax,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "notifyFax", $$v)
                                        },
                                        expression: "form.notifyFax"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c("el-form-item", {
                          staticClass: "auto-width",
                          attrs: { label: "ALSO NOTIFY" }
                        }),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Name") }
                          },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "alsoNotifyLine1",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.alsoNotify.writable,
                                "filter-chars": false,
                                "use-read-only": true,
                                "auto-uppercase": true
                              },
                              on: { change: _vm.alsoChange },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    "ALSO NOTIFY",
                                    _vm.form.alsoNotify,
                                    function(val) {
                                      _vm.summarizeAlso(val)
                                    },
                                    false,
                                    null,
                                    true,
                                    {
                                      warningCount: 45,
                                      maxChar: 0,
                                      autoUppercase: true,
                                      autoHalfWord: true
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.alsoNotify.line1,
                                callback: function($$v) {
                                  _vm.$set(_vm.alsoNotify, "line1", $$v)
                                },
                                expression: "alsoNotify.line1"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("SeaExport.Addr") + "1" }
                          },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "alsoNotifyLine2",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.alsoNotify.writable,
                                "filter-chars": false,
                                "use-read-only": true,
                                "auto-uppercase": true
                              },
                              on: { change: _vm.alsoChange },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    "ALSO NOTIFY",
                                    _vm.form.alsoNotify,
                                    function(val) {
                                      _vm.summarizeAlso(val)
                                    },
                                    false,
                                    null,
                                    true,
                                    {
                                      warningCount: 45,
                                      maxChar: 0,
                                      autoUppercase: true,
                                      autoHalfWord: true
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.alsoNotify.line2,
                                callback: function($$v) {
                                  _vm.$set(_vm.alsoNotify, "line2", $$v)
                                },
                                expression: "alsoNotify.line2"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("SeaExport.Addr") + "2" }
                          },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "alsoNotifyLine3",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.alsoNotify.writable,
                                "filter-chars": false,
                                "use-read-only": true,
                                "auto-uppercase": true
                              },
                              on: { change: _vm.alsoChange },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    "ALSO NOTIFY",
                                    _vm.form.alsoNotify,
                                    function(val) {
                                      _vm.summarizeAlso(val)
                                    },
                                    false,
                                    null,
                                    true,
                                    {
                                      warningCount: 45,
                                      maxChar: 0,
                                      autoUppercase: true,
                                      autoHalfWord: true
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.alsoNotify.line3,
                                callback: function($$v) {
                                  _vm.$set(_vm.alsoNotify, "line3", $$v)
                                },
                                expression: "alsoNotify.line3"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Country") }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    no: "alsoNotifyCountry",
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.alsoNotify.writable
                                  },
                                  model: {
                                    value: _vm.form.alsoNotifyCountry,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "alsoNotifyCountry",
                                        $$v
                                      )
                                    },
                                    expression: "form.alsoNotifyCountry"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_CityP"),
                                      "label-width": "70px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        no: "alsoNotifyCity",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.alsoNotify.writable
                                      },
                                      model: {
                                        value: _vm.form.alsoNotifyCity,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "alsoNotifyCity",
                                            $$v
                                          )
                                        },
                                        expression: "form.alsoNotifyCity"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Province1") }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    no: "alsoNotifyProvince",
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.alsoNotify.writable
                                  },
                                  model: {
                                    value: _vm.form.alsoNotifyProvince,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "alsoNotifyProvince",
                                        $$v
                                      )
                                    },
                                    expression: "form.alsoNotifyProvince"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_PostalCode"
                                      ),
                                      "label-width": "70px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        no: "alsoNotifyZipCode",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.alsoNotify.writable
                                      },
                                      model: {
                                        value: _vm.form.alsoNotifyZipCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "alsoNotifyZipCode",
                                            $$v
                                          )
                                        },
                                        expression: "form.alsoNotifyZipCode"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("CargoMsg.Cargo_Tel") } },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    no: "alsoNotifyMobile",
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.alsoNotify.writable
                                  },
                                  model: {
                                    value: _vm.form.alsoNotifyMobile,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "alsoNotifyMobile",
                                        $$v
                                      )
                                    },
                                    expression: "form.alsoNotifyMobile"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_email"),
                                      "label-width": "70px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        no: "alsoNotifyEmail",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.alsoNotify.writable
                                      },
                                      model: {
                                        value: _vm.form.alsoNotifyEmail,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "alsoNotifyEmail",
                                            $$v
                                          )
                                        },
                                        expression: "form.alsoNotifyEmail"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Contact") }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "padding-bottom": "5px"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    no: "alsoNotifyContact",
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.alsoNotify.writable
                                  },
                                  model: {
                                    value: _vm.form.alsoNotifyContact,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "alsoNotifyContact",
                                        $$v
                                      )
                                    },
                                    expression: "form.alsoNotifyContact"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Fax",
                                      "label-width": "70px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        no: "alsoNotifyFax",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.alsoNotify.writable
                                      },
                                      model: {
                                        value: _vm.form.alsoNotifyFax,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "alsoNotifyFax",
                                            $$v
                                          )
                                        },
                                        expression: "form.alsoNotifyFax"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.payment.viewable &&
                _vm.job.paymentTermMBL === "3P"
                  ? _c(
                      "div",
                      { attrs: { slot: "payment" }, slot: "payment" },
                      [
                        _c(
                          "el-form-item",
                          { staticClass: "auto-width" },
                          [
                            _c("line-label", {
                              class: _vm.elementDict.payment.isRequire
                                ? "blue"
                                : "",
                              attrs: {
                                slot: "label",
                                label: _vm.elementDict.payment.label
                              },
                              slot: "label"
                            }),
                            _c(
                              "div",
                              {
                                staticStyle: { display: "flex", width: "100%" }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    no: "paymentCode",
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.payment.writable
                                  },
                                  model: {
                                    value: _vm.form.paymentCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "paymentCode", $$v)
                                    },
                                    expression: "form.paymentCode"
                                  }
                                }),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      no: "BringInData",
                                      type: "primary",
                                      disabled:
                                        _vm.readonly ||
                                        !_vm.elementDict.payment.writable
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.paymentImportData(false)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_BringInData")
                                      ) + " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Name") }
                          },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "paymentLine1",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.payment.writable,
                                "filter-chars": false,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "paymentLine1",
                                    "paymentLine2",
                                    0
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showPaymentDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.paymentLine1,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "paymentLine1", $$v)
                                },
                                expression: "form.paymentLine1"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("SeaExport.Addr") + "1" }
                          },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "paymentLine2",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.payment.writable,
                                "filter-chars": false,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "paymentLine2",
                                    "paymentLine3",
                                    0
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showPaymentDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.paymentLine2,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "paymentLine2", $$v)
                                },
                                expression: "form.paymentLine2"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("SeaExport.Addr") + "2" }
                          },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "paymentLine3",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.payment.writable,
                                "filter-chars": false,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "paymentLine3",
                                    "paymentLine4",
                                    0
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showPaymentDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.paymentLine3,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "paymentLine3", $$v)
                                },
                                expression: "form.paymentLine3"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Country") }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    no: "paymentCountry",
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.payment.writable
                                  },
                                  model: {
                                    value: _vm.form.paymentCountry,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "paymentCountry", $$v)
                                    },
                                    expression: "form.paymentCountry"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_CityP"),
                                      "label-width": "70px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        no: "paymentCity",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.payment.writable
                                      },
                                      model: {
                                        value: _vm.form.paymentCity,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "paymentCity", $$v)
                                        },
                                        expression: "form.paymentCity"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Province1") }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    no: "paymentProvince",
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.payment.writable
                                  },
                                  model: {
                                    value: _vm.form.paymentProvince,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "paymentProvince", $$v)
                                    },
                                    expression: "form.paymentProvince"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_PostalCode"
                                      ),
                                      "label-width": "70px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        no: "paymentPostalCode",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.payment.writable
                                      },
                                      model: {
                                        value: _vm.form.paymentPostalCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "paymentPostalCode",
                                            $$v
                                          )
                                        },
                                        expression: "form.paymentPostalCode"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("CargoMsg.Cargo_Tel") } },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    no: "paymentPhone",
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.payment.writable
                                  },
                                  model: {
                                    value: _vm.form.paymentPhone,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "paymentPhone", $$v)
                                    },
                                    expression: "form.paymentPhone"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_email"),
                                      "label-width": "70px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        no: "paymentEmail",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.payment.writable
                                      },
                                      model: {
                                        value: _vm.form.paymentEmail,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "paymentEmail",
                                            $$v
                                          )
                                        },
                                        expression: "form.paymentEmail"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Contact") }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "padding-bottom": "5px"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    no: "paymentContact",
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.payment.writable
                                  },
                                  model: {
                                    value: _vm.form.paymentContact,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "paymentContact", $$v)
                                    },
                                    expression: "form.paymentContact"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Fax",
                                      "label-width": "70px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        no: "paymentFax",
                                        disabled:
                                          _vm.readonly ||
                                          !_vm.elementDict.payment.writable
                                      },
                                      model: {
                                        value: _vm.form.paymentFax,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "paymentFax", $$v)
                                        },
                                        expression: "form.paymentFax"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : _vm._e(),
          _vm.elementDict.syncContainerInfoTotal.viewable
            ? _c(
                "el-form-item",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end"
                  },
                  attrs: { slot: "syncContainerInfoTotal" },
                  slot: "syncContainerInfoTotal"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.syncContainerInfoTotal.writable
                      },
                      on: { click: _vm.syncContainerInfoDialogHandle }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.SyncContainerInfoTotal")))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.quantity.viewable
            ? _c(
                "el-form-item",
                {
                  class: _vm.variableCss.quantity,
                  attrs: { slot: "quantity" },
                  slot: "quantity"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.quantity.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.quantity.label
                    },
                    slot: "label"
                  }),
                  _c("auto-number-input", {
                    attrs: {
                      no: "18",
                      precision: 0,
                      min: 0,
                      disabled:
                        !_vm.isJydEditJobFields ||
                        _vm.readonly ||
                        !_vm.elementDict.quantity.writable
                    },
                    on: {
                      change: function($event) {
                        return _vm.pm.quantity_Change(_vm.form.quantity)
                      }
                    },
                    model: {
                      value: _vm.form.quantity,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "quantity", $$v)
                      },
                      expression: "form.quantity"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.packing.viewable
            ? _c(
                "el-form-item",
                {
                  class: _vm.variableCss.packing,
                  attrs: { slot: "packing" },
                  slot: "packing"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.packing.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.packing.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-packing-select", {
                    attrs: {
                      no: "19",
                      "default-value": _vm.form.packing,
                      disabled:
                        _vm.readonly || !_vm.elementDict.packing.writable
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.packing_Change(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.insideQuantity.viewable
            ? _c(
                "el-form-item",
                {
                  class: _vm.variableCss.insideQuantity,
                  attrs: { slot: "insideQuantity" },
                  slot: "insideQuantity"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.insideQuantity.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.insideQuantity.label
                    },
                    slot: "label"
                  }),
                  _c("auto-number-input", {
                    attrs: {
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.insideQuantity.writable,
                      no: "20",
                      precision: 0,
                      min: 0
                    },
                    model: {
                      value: _vm.form.insideQuantity,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "insideQuantity", $$v)
                      },
                      expression: "form.insideQuantity"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.insidePacking.viewable
            ? _c(
                "el-form-item",
                {
                  class: _vm.variableCss.insidePacking,
                  attrs: { slot: "insidePacking" },
                  slot: "insidePacking"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.insidePacking.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.insidePacking.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-packing-select", {
                    attrs: {
                      no: "21",
                      "default-value": _vm.form.insidePacking,
                      disabled:
                        _vm.readonly || !_vm.elementDict.insidePacking.writable
                    },
                    on: {
                      change: function(p) {
                        _vm.form.insidePacking = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.weight.viewable
            ? _c(
                "el-form-item",
                {
                  class: _vm.variableCss.weight,
                  attrs: { slot: "weight" },
                  slot: "weight"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.weight.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.weight.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "form-item-input",
                      class: _vm.readonly ? "input-disabled" : ""
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { flex: "1" },
                        attrs: {
                          no: "22",
                          precision: 3,
                          min: 0,
                          controls: false,
                          disabled:
                            !_vm.isJydEditJobFields ||
                            _vm.readonly ||
                            !_vm.elementDict.weight.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.calculateChargeWeight()
                          }
                        },
                        model: {
                          value: _vm.form.weight,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "weight", $$v)
                          },
                          expression: "form.weight"
                        }
                      }),
                      _c("span", [_vm._v("KGS")])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cubage.viewable
            ? _c(
                "el-form-item",
                {
                  class: _vm.variableCss.cubage,
                  attrs: { slot: "cubage" },
                  slot: "cubage"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cubage.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cubage.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "form-item-input",
                      class: _vm.readonly ? "input-disabled" : ""
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { flex: "1" },
                        attrs: {
                          no: "23",
                          precision: 3,
                          min: 0,
                          controls: false,
                          disabled:
                            !_vm.isJydEditJobFields ||
                            _vm.readonly ||
                            !_vm.elementDict.cubage.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.calculateChargeWeight()
                          }
                        },
                        model: {
                          value: _vm.form.cubage,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cubage", $$v)
                          },
                          expression: "form.cubage"
                        }
                      }),
                      _c("span", [_vm._v("CBM")])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.chargeWeight.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "chargeWeight" }, slot: "chargeWeight" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.chargeWeight.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.chargeWeight.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "form-item-input",
                      class: _vm.readonly ? "input-disabled" : ""
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { flex: "1" },
                        attrs: {
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.chargeWeight.writable,
                          no: "24",
                          precision: 3,
                          min: 0,
                          controls: false
                        },
                        model: {
                          value: _vm.form.chargeWeight,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "chargeWeight", $$v)
                          },
                          expression: "form.chargeWeight"
                        }
                      }),
                      _c("span", [_vm._v("M/T")])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoEnglishName.viewable
            ? _c(
                "el-form-item",
                {
                  class: "auto-width " + _vm.variableCss.cargoEnglishName,
                  attrs: { slot: "cargoEnglishName" },
                  slot: "cargoEnglishName"
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "flex-end"
                      }
                    },
                    [
                      _vm.job.typeMBL === _vm.BillType.MERGE_BILL_TYPE.code
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                no: "25",
                                type: "primary",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.cargoEnglishName.writable
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pm.getCargoEnglishNameFromMergeJob()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.CopyEnglishDescriptionOfGoodsFromMergeJob"
                                  )
                                )
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.cargoEnglishName.viewable,
                  expression: "elementDict.cargoEnglishName.viewable"
                }
              ],
              staticClass: "auto-width",
              class: _vm.variableCss.cargoEnglishName,
              attrs: { slot: "cargoEnglishName" },
              slot: "cargoEnglishName"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.cargoEnglishName.isRequire ? "blue" : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.cargoEnglishName.label
                },
                slot: "label"
              }),
              _c("cargo-rich-textarea", {
                ref: "cargoTextarea1",
                staticStyle: { height: "110px" },
                attrs: {
                  "show-count": true,
                  no: "26",
                  "warning-count": _vm.seMarkWarningColor,
                  "text-chars": _vm.seMarkMaxChars,
                  "wrap-symbol": "r",
                  disabled:
                    !_vm.isEdit || !_vm.elementDict.cargoEnglishName.writable,
                  "auto-uppercase": _vm.isUppercaseByConfig,
                  "auto-half-word": ""
                },
                nativeOn: {
                  dblclick: function($event) {
                    _vm.showAdvanceTextDialog(
                      _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                      _vm.form.cargoEnglishName,
                      function(val) {
                        _vm.form.cargoEnglishName = val
                      },
                      _vm.isUppercaseByConfig,
                      {
                        warningCount: _vm.seMarkWarningColor,
                        maxChar: _vm.seMarkMaxChars,
                        autoHalfWord: true,
                        autoUppercase: _vm.isUppercaseByConfig
                      }
                    )
                  }
                },
                model: {
                  value: _vm.form.cargoEnglishName,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "cargoEnglishName", $$v)
                  },
                  expression: "form.cargoEnglishName"
                }
              })
            ],
            1
          ),
          _vm.elementDict.mark.viewable
            ? _c(
                "template",
                { slot: "mark" },
                [
                  _c(
                    "el-form-item",
                    { class: "auto-width " + _vm.variableCss.mark },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "flex-end"
                          }
                        },
                        [
                          _vm.job.typeMBL === _vm.BillType.MERGE_BILL_TYPE.code
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "27",
                                    type: "primary",
                                    disabled:
                                      _vm.readonly ||
                                      !_vm.elementDict.mark.writable
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.getMarkFromMergeJob()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.CopyMarkFromMergeJob")
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.mark.viewable,
                  expression: "elementDict.mark.viewable"
                }
              ],
              class: "auto-width " + _vm.variableCss.mark,
              attrs: { slot: "mark" },
              slot: "mark"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.mark.isRequire ? "blue" : "",
                attrs: { slot: "label", label: _vm.elementDict.mark.label },
                slot: "label"
              }),
              _c("cargo-rich-textarea", {
                ref: "cargoTextarea2",
                staticStyle: { height: "110px" },
                attrs: {
                  "show-count": true,
                  no: "28",
                  "warning-count": _vm.seMarkWarningColor,
                  "text-chars": _vm.seMarkMaxChars,
                  disabled: !_vm.isEdit || !_vm.elementDict.mark.writable,
                  "wrap-symbol": "r",
                  "auto-uppercase": _vm.isUppercaseByConfig,
                  "auto-half-word": ""
                },
                nativeOn: {
                  dblclick: function($event) {
                    _vm.showAdvanceTextDialog(
                      _vm.$t("SeaExport.Marks"),
                      _vm.form.mark,
                      function(val) {
                        _vm.form.mark = val
                      },
                      _vm.isUppercaseByConfig,
                      {
                        warningCount: _vm.seMarkWarningColor,
                        maxChar: _vm.seMarkMaxChars,
                        autoHalfWord: true,
                        autoUppercase: _vm.isUppercaseByConfig
                      }
                    )
                  }
                },
                model: {
                  value: _vm.form.mark,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "mark", $$v)
                  },
                  expression: "form.mark"
                }
              })
            ],
            1
          ),
          _vm.elementDict.quantitySum.viewable
            ? _c(
                "el-form-item",
                {
                  staticClass: "auto-width",
                  attrs: { slot: "quantitySum" },
                  slot: "quantitySum"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.quantitySum.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.quantitySum.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: true, no: "56" },
                    model: {
                      value: _vm.form.quantitySum,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "quantitySum", $$v)
                      },
                      expression: "form.quantitySum"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.hsCode.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "hsCode" }, slot: "hsCode" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.hsCode.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.hsCode.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "hsCode",
                      type: "textarea",
                      rows: 5,
                      disabled: _vm.readonly || !_vm.elementDict.hsCode.writable
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.hsCode.label,
                          _vm.form.hsCode,
                          function(val) {
                            _vm.form.hsCode = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.hsCode,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "hsCode", $$v)
                      },
                      expression: "form.hsCode"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.mblNbr2.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "mblNbr2" }, slot: "mblNbr2" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.mblNbr2.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.mblNbr2.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "29",
                      disabled:
                        _vm.readonly || !_vm.elementDict.mblNbr2.writable
                    },
                    model: {
                      value: _vm.form.mblNbr2,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "mblNbr2", $$v)
                      },
                      expression: "form.mblNbr2"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.hblNbr2.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "hblNbr2" }, slot: "hblNbr2" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.hblNbr2.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.hblNbr2.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: true, value: _vm.form.hblNbr2, no: "52" }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.txtFirstVesselVoyage.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "txtFirstVesselVoyage" },
                  slot: "txtFirstVesselVoyage"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.txtFirstVesselVoyage.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.txtFirstVesselVoyage.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: true,
                      value: _vm.txtFirstVesselVoyage,
                      no: "53"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.sailingDate.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "sailingDate" }, slot: "sailingDate" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.sailingDate.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.sailingDate.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: true, value: _vm.sailingDate, no: "54" }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dispatchingPlaceCode.viewable
            ? _c(
                "el-form-item",
                {
                  class: _vm.variableCss.dispatchingPlace,
                  attrs: { slot: "dispatchingPlaceCode" },
                  slot: "dispatchingPlaceCode"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dispatchingPlaceCode.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.dispatchingPlaceCode.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      disabled: true,
                      "select-type": _vm.selectTypeNames.basic_data_Seaport,
                      filterable: "",
                      "default-value": _vm.form.dispatchingPlaceCode || "",
                      "tag-name": "englishName",
                      no: "55"
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.pm.portChange(p, "dispatchingPlace")
                      }
                    }
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "30",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.dispatchingPlaceCode.writable
                    },
                    model: {
                      value: _vm.form.dispatchingPlace,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "dispatchingPlace", $$v)
                      },
                      expression: "form.dispatchingPlace"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.loadingPortCode.viewable
            ? _c(
                "el-form-item",
                {
                  class: _vm.variableCss.loadingPort,
                  attrs: { slot: "loadingPortCode" },
                  slot: "loadingPortCode"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.loadingPortCode.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.loadingPortCode.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      disabled: true,
                      "select-type": _vm.selectTypeNames.basic_data_Seaport,
                      filterable: "",
                      "default-value": _vm.form.loadingPortCode || "",
                      "tag-name": "englishName",
                      no: "loadingPortCode"
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.pm.portChange(p, "loadingPort")
                      }
                    }
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "31",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.loadingPortCode.writable
                    },
                    model: {
                      value: _vm.form.loadingPort,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "loadingPort", $$v)
                      },
                      expression: "form.loadingPort"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dischargingPortCode.viewable
            ? _c(
                "el-form-item",
                {
                  class: _vm.variableCss.dischargingPort,
                  attrs: { slot: "dischargingPortCode" },
                  slot: "dischargingPortCode"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dischargingPortCode.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.dischargingPortCode.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      disabled: true,
                      "select-type": _vm.selectTypeNames.basic_data_Seaport,
                      filterable: "",
                      "default-value": _vm.form.dischargingPortCode || "",
                      "tag-name": "englishName",
                      no: "dischargingPortCode"
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.pm.portChange(p, "dischargingPort")
                      }
                    }
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "32",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.dischargingPortCode.writable
                    },
                    model: {
                      value: _vm.form.dischargingPort,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "dischargingPort", $$v)
                      },
                      expression: "form.dischargingPort"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.destinationPortCode.viewable
            ? _c(
                "el-form-item",
                {
                  class: _vm.variableCss.destinationPort,
                  attrs: { slot: "destinationPortCode" },
                  slot: "destinationPortCode"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.destinationPortCode.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.destinationPortCode.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      disabled: true,
                      "select-type": _vm.selectTypeNames.basic_data_Seaport,
                      filterable: "",
                      "default-value": _vm.form.destinationPortCode || "",
                      "tag-name": "englishName",
                      no: "destinationPortCode"
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.pm.portChange(p, "destinationPort")
                      }
                    }
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "33",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.destinationPortCode.writable
                    },
                    model: {
                      value: _vm.form.destinationPort,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "destinationPort", $$v)
                      },
                      expression: "form.destinationPort"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.destinationPlace.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "destinationPlace" },
                  slot: "destinationPlace"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.destinationPlace.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.destinationPlace.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "34",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.destinationPlace.writable
                    },
                    model: {
                      value: _vm.form.destinationPlace,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "destinationPlace", $$v)
                      },
                      expression: "form.destinationPlace"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.paymentTerm.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "paymentTerm" }, slot: "paymentTerm" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.paymentTerm.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.paymentTerm.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "35",
                      disabled:
                        _vm.readonly || !_vm.elementDict.paymentTerm.writable,
                      value: _vm.ColumnUtils.paymentTermLabelFunc(
                        _vm.form.paymentTerm
                      )
                    },
                    on: {
                      input: function(val) {
                        _vm.form.paymentTerm = val
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.paymentPlaceBL.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "paymentPlaceBL" }, slot: "paymentPlaceBL" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.paymentPlaceBL.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.paymentPlaceBL.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: true, value: _vm.form.paymentPlaceBL }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.freightTerm.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "freightTerm" }, slot: "freightTerm" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.freightTerm.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.freightTerm.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: true, value: _vm.job.freightTerm }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.blNumber.viewable
            ? _c(
                "el-form-item",
                {
                  class: _vm.variableCss.BLNumber,
                  attrs: { slot: "blNumber" },
                  slot: "blNumber"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.blNumber.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.blNumber.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    class: _vm.variableCss.BLNumber,
                    attrs: {
                      no: "36",
                      disabled:
                        _vm.readonly || !_vm.elementDict.blNumber.writable
                    },
                    model: {
                      value: _vm.form.blNumber,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "blNumber", $$v)
                      },
                      expression: "form.blNumber"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.signPlaceBL.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "signPlaceBL" }, slot: "signPlaceBL" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.signPlaceBL.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.signPlaceBL.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "37",
                      disabled:
                        _vm.readonly || !_vm.elementDict.signPlaceBL.writable
                    },
                    model: {
                      value: _vm.form.signPlaceBL,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "signPlaceBL", $$v)
                      },
                      expression: "form.signPlaceBL"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.signDateBL.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "signDateBL" }, slot: "signDateBL" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.signDateBL.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.signDateBL.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "38",
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      disabled:
                        _vm.readonly || !_vm.elementDict.signDateBL.writable
                    },
                    model: {
                      value: _vm.form.signDateBL,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "signDateBL", $$v)
                      },
                      expression: "form.signDateBL"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.remarks.viewable
            ? _c(
                "el-form-item",
                {
                  class: _vm.variableCss.remarks,
                  attrs: { slot: "remarks" },
                  slot: "remarks"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.remarks.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.remarks.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-rich-textarea", {
                    staticStyle: { height: "110px" },
                    attrs: {
                      no: "39",
                      disabled:
                        _vm.readonly || !_vm.elementDict.remarks.writable,
                      "text-chars": 0,
                      "wrap-symbol": "r"
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.BlRemarks"),
                          _vm.form.remarks,
                          function(val) {
                            _vm.form.remarks = val
                          },
                          true,
                          {
                            warningCount: 45,
                            maxChar: 0
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "remarks", $$v)
                      },
                      expression: "form.remarks"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.job.typeMBL === _vm.BillType.SPLIT_BILL_TYPE.code
            ? _c(
                "el-form-item",
                {
                  staticClass: "auto-width",
                  attrs: {
                    slot: "orderBusinessAssociation",
                    "label-width": "0"
                  },
                  slot: "orderBusinessAssociation"
                },
                [
                  _c("cargo-ag-grid", {
                    key: "splitOrder",
                    staticStyle: { width: "100%", height: "200px" },
                    attrs: {
                      no: "40",
                      "grid-options": _vm.splitOrder.gridOptions,
                      "column-defs": _vm.splitOrder.columnDefs,
                      "row-data": _vm.splitOrderFinalRowData
                    },
                    on: { gridReady: _vm.splitOrderReady }
                  }),
                  _c("div", { staticStyle: { padding: "5px 0" } }, [
                    _c(
                      "div",
                      { staticStyle: { float: "right" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "41",
                              type: "primary",
                              disabled: _vm.readonly
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.onAddSplitDocEvent()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Add")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "42",
                              type: "danger",
                              disabled: _vm.readonly
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.onRemoveSliptDocEvent()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm.job.typeMBL === _vm.BillType.MERGE_BILL_TYPE.code
            ? _c(
                "el-form-item",
                {
                  staticClass: "auto-width",
                  attrs: {
                    slot: "orderBusinessAssociation",
                    "label-width": "0"
                  },
                  slot: "orderBusinessAssociation"
                },
                [
                  _c("cargo-ag-grid", {
                    key: "mergeOrder",
                    staticStyle: { width: "100%", height: "200px" },
                    attrs: {
                      no: "43",
                      "config-module": "150005",
                      "grid-options": _vm.mergeOrder.gridOptions,
                      "column-defs": _vm.mergeOrder.columnDefs,
                      "row-data": _vm.mergeOrderFinalRowData
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.mergeOrder.gridApi = params.api
                      }
                    }
                  }),
                  _c("div", { staticStyle: { padding: "5px 0" } }, [
                    _c(
                      "div",
                      { staticStyle: { float: "right" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "44",
                              type: "primary",
                              disabled: _vm.readonly
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.onJobsAdd()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Add3")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "45",
                              type: "danger",
                              disabled: _vm.readonly
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.onJobsRemove()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.releaseType.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "releaseType" }, slot: "releaseType" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.releaseType.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.releaseType.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        no: "46",
                        disabled:
                          _vm.readonly || !_vm.elementDict.releaseType.writable,
                        value: _vm.form.releaseType || ""
                      },
                      on: {
                        input: function(val) {
                          _vm.form.releaseType = val
                        },
                        change: function(val) {
                          _vm.pm.cmbreleaseTypeMBLChangeHandler(val)
                        }
                      }
                    },
                    _vm._l(_vm.blModeList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.serialNumber }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.billingOfLadingRecord.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "billingOfLadingRecord" },
                  slot: "billingOfLadingRecord"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.billingOfLadingRecord.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.billingOfLadingRecord.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "a",
                    {
                      staticClass:
                        "el-button el-button--primary el-button--mini",
                      class: _vm.isEdit ? "is-disabled" : "",
                      staticStyle: {
                        display: "inline-block",
                        width: "100%",
                        "text-align": "center"
                      },
                      attrs: {
                        no: "70",
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.billingOfLadingRecord.writable
                      },
                      on: {
                        click: function($event) {
                          _vm.isEdit
                            ? ""
                            : (_vm.statusChangeHistoryDialog.visible = true)
                        }
                      }
                    },
                    [_vm._v("……")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.lblCfrState.viewable
            ? _c(
                "el-form-item",
                {
                  staticClass: "red ",
                  attrs: { slot: "lblCfrState" },
                  slot: "lblCfrState"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.lblCfrState.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.lblCfrState.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { value: _vm.lblCfrState, disabled: true, no: "57" }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.billLadingIssued.viewable
            ? _c(
                "el-form-item",
                {
                  staticClass: "red",
                  attrs: { slot: "billLadingIssued" },
                  slot: "billLadingIssued"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.billLadingIssued.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.billLadingIssued.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: true, no: "58" },
                    model: {
                      value: _vm.billLadingIssued,
                      callback: function($$v) {
                        _vm.billLadingIssued = $$v
                      },
                      expression: "billLadingIssued"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.lblReleaseState.viewable
            ? _c(
                "el-form-item",
                {
                  staticClass: "red",
                  attrs: { slot: "lblReleaseState" },
                  slot: "lblReleaseState"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.lblReleaseState.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.lblReleaseState.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    staticStyle: { "margin-bottom": "5px" },
                    attrs: {
                      disabled: true,
                      value: _vm.lblReleaseState,
                      no: "59"
                    }
                  }),
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_SingleRelease_singleRelease"],
                          expression: "['button_SingleRelease_singleRelease']"
                        }
                      ],
                      staticClass:
                        "el-button el-button--primary el-button--mini",
                      class: _vm.btnReleasingDisabled ? "is-disabled" : "",
                      staticStyle: { float: "right", "margin-left": "5px" },
                      attrs: { no: "60" },
                      on: {
                        click: function($event) {
                          _vm.btnReleasingDisabled
                            ? ""
                            : _vm.pm.btnReleasingClickHandler()
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.form.cfmState === 10
                            ? _vm.$t("SeaExport.CancelReleasing")
                            : _vm.$t("SeaExport.Releasing")
                        )
                      )
                    ]
                  ),
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_SingleRelease_getBack"],
                          expression: "['button_SingleRelease_getBack']"
                        }
                      ],
                      staticClass:
                        "el-button el-button--primary el-button--mini",
                      class: _vm.btnGetBackDisabled ? "is-disabled" : "",
                      staticStyle: { float: "right" },
                      attrs: { no: "61" },
                      on: {
                        click: function($event) {
                          _vm.btnGetBackDisabled
                            ? ""
                            : _vm.pm.btnGetBackClickHandler()
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.form.bliStatus === 7
                            ? _vm.$t("SeaExport.CancelGetBack")
                            : _vm.$t("SeaExport.Back")
                        )
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.requestReleaseState.viewable
            ? _c(
                "el-form-item",
                {
                  staticClass: "red",
                  attrs: { slot: "requestReleaseState" },
                  slot: "requestReleaseState"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.requestReleaseState.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.requestReleaseState.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      value:
                        _vm.form.requestReleaseState === 0
                          ? _vm.$t("SeaExport.NotApplying")
                          : _vm.$t("SeaExport.Requested"),
                      disabled: true
                    }
                  }),
                  _c(
                    "cargo-button-container",
                    {
                      staticStyle: { float: "right", "margin-left": "5px" },
                      attrs: {
                        no: "requestReleaseState",
                        disabled:
                          _vm.btnReleasingDisabled ||
                          _vm.elementDict.requestReleaseState.writable
                      },
                      on: {
                        click: function($event) {
                          return _vm.pm.btnRequestReleasingClickHandler()
                        }
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_M/HBL_SingleReleaseMBL"],
                              expression: "['button_M/HBL_SingleReleaseMBL']"
                            }
                          ],
                          attrs: { type: "primary" }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.form.requestReleaseState === 0
                                ? _vm.$t("SeaExport.ApplyForARelease")
                                : _vm.$t(
                                    "SeaExport.WithdrawTheRequestForRelease"
                                  )
                            ) + " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.reviewDate.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "reviewDate" }, slot: "reviewDate" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.reviewDate.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.reviewDate.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled: true,
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      no: "62"
                    },
                    model: {
                      value: _vm.form.reviewDate,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "reviewDate", $$v)
                      },
                      expression: "form.reviewDate"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.releaseDate.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "releaseDate" }, slot: "releaseDate" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.releaseDate.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.releaseDate.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled: true,
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      no: "63"
                    },
                    model: {
                      value: _vm.form.releaseDate,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "releaseDate", $$v)
                      },
                      expression: "form.releaseDate"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.withholdDate.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "withholdDate" }, slot: "withholdDate" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.withholdDate.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.withholdDate.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled: true,
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      no: "64"
                    },
                    model: {
                      value: _vm.form.withholdDate,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "withholdDate", $$v)
                      },
                      expression: "form.withholdDate"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.txtCarrierScAc.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "txtCarrierScAc" }, slot: "txtCarrierScAc" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.txtCarrierScAc.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.txtCarrierScAc.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: true,
                      value: _vm.job.carrierScac || _vm.txtCarrierScAc,
                      no: "65"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.txtBookingAgentScAc.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "txtBookingAgentScAc" },
                  slot: "txtBookingAgentScAc"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.txtBookingAgentScAc.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.txtBookingAgentScAc.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: true,
                      value: _vm.txtBookingAgentScAc,
                      no: "66"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.seaeq.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "seaeq" }, slot: "seaeq" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.seaeq.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.seaeq.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-rich-textarea", {
                    staticStyle: { height: "110px" },
                    attrs: {
                      no: "47",
                      disabled: _vm.readonly || !_vm.elementDict.seaeq.writable,
                      "text-chars": 0,
                      "wrap-symbol": "r"
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.ContainerAmount"),
                          _vm.form.seaeq,
                          function(val) {
                            _vm.form.seaeq = val
                          },
                          true,
                          {
                            warningCount: 45,
                            maxChar: 0
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.seaeq,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "seaeq", $$v)
                      },
                      expression: "form.seaeq"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.container.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "container" }, slot: "container" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.container.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.container.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-rich-textarea", {
                    staticStyle: { height: "110px" },
                    attrs: {
                      no: "48",
                      disabled:
                        _vm.readonly || !_vm.elementDict.container.writable,
                      "text-chars": 0,
                      "wrap-symbol": "r"
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.container.label,
                          _vm.form.container,
                          function(val) {
                            _vm.form.container = val
                          },
                          true,
                          {
                            warningCount: 45,
                            maxChar: 0
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.container,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "container", $$v)
                      },
                      expression: "form.container"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.withholdReason.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "withholdReason" }, slot: "withholdReason" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.withholdReason.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.withholdReason.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: true,
                      value: _vm.form.withholdReason,
                      type: "textarea",
                      rows: 5,
                      no: "67"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.portRequirement.viewable
            ? _c(
                "el-form-item",
                { attrs: { slot: "portRequirement" }, slot: "portRequirement" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.portRequirement.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.portRequirement.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.portRequirement.writable,
                      no: "portRequirement",
                      type: "textarea",
                      rows: 5
                    },
                    model: {
                      value: _vm.form.portRequirement,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "portRequirement", $$v)
                      },
                      expression: "form.portRequirement"
                    }
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "line-height": "16px",
                        "margin-top": "5px",
                        cursor: "pointer"
                      },
                      on: {
                        click: function($event) {
                          return _vm.downloadAttachment(
                            _vm.form.regionWarehouseMappingUuid
                          )
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-paperclip",
                        staticStyle: { "font-size": "16px" }
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "12px",
                            "text-decoration": "underline",
                            color: "blue"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SystemMaintenance.PortRequirementsRelatedDocuments"
                              )
                            )
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.billOfLadingPackingInfo.viewable &&
          _vm.showEdiContainer &&
          _vm.form.docType
            ? _c(
                "div",
                {
                  staticClass: "section",
                  attrs: { slot: "billOfLadingPackingInfo" },
                  slot: "billOfLadingPackingInfo"
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.BillOfLadingPackingInfo")))
                  ]),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.isEdit &&
                                _vm.elementDict.billOfLadingPackingInfo
                                  .writable,
                              expression:
                                "isEdit && elementDict.billOfLadingPackingInfo.writable"
                            }
                          ],
                          staticStyle: { padding: "5px 0" }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { no: "49", type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.cargoDocUsageSelectedDialog.visible = true
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.AddPackingInfo")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { no: "50", type: "primary" },
                              on: {
                                click: _vm.removeContainerUsageClickHandler
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.RemovePackingInfo"))
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c("cargo-ag-grid", {
                        staticStyle: { width: "100%", height: "350px" },
                        attrs: {
                          no: "51",
                          "grid-options": _vm.gridOptions,
                          "column-defs": _vm.columnDefs,
                          "row-data": _vm.ediContainerFinalRowData
                        },
                        on: {
                          gridReady: function(params) {
                            _vm.gridApi = params.api
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "auto-uppercase": _vm.advanceTextDialog.isUppercase,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              disabled: _vm.readonly,
              no: "advanceTextDialogTextarea"
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { type: "primary", no: "68" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "69" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("bill-address-dialog", {
        attrs: {
          visible: _vm.billAddressDialog.visible,
          params: _vm.form,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c("job-no-transcribe-dialog", {
        attrs: {
          visible: _vm.searchBillNoDialog.visible,
          params: _vm.searchBillNoDialog.params
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.searchBillNoDialog, "visible", $event)
          },
          selected: _vm.searchBillNoDialog.selectHandler
        }
      }),
      _c("status-change-history-dialog", {
        attrs: {
          visible: _vm.statusChangeHistoryDialog.visible,
          "business-data-id": _vm.form.uuid
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.statusChangeHistoryDialog, "visible", $event)
          }
        }
      }),
      _c("add-cargo-doc-container-dialog", {
        attrs: {
          visible: _vm.cargoDocUsageSelectedDialog.visible,
          job: _vm.job,
          "doc-type": _vm.CargoDocConsts.MBL2,
          "uuid-not-empty": true,
          "cargo-docs":
            _vm.job.typeMBL === _vm.BillType.SPLIT_BILL_TYPE.code
              ? _vm.splitOrderFinalRowData
              : null
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cargoDocUsageSelectedDialog, "visible", $event)
          },
          callback: _vm.cargoDocUsageSelectedDialog.callback
        }
      }),
      _vm.emailInput.visible
        ? _c("email-input", {
            attrs: {
              visible: _vm.emailInput.visible,
              context: _vm.context,
              job: _vm.job,
              source: "tabMBL2",
              "is-copy-link": true,
              "job-eamil-data": _vm.jobEamilData,
              "send-email-data": _vm.emailInput,
              "send-call-back": _vm.onEmailExecute
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.emailInput, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("match-history-dialog", {
        attrs: {
          visible: _vm.matchHistoryDialog.visible,
          "cargo-doc-uuid": _vm.form.uuid
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.matchHistoryDialog, "visible", $event)
          }
        }
      }),
      _c("sync-container-info-dialog", {
        ref: "syncContainerInfoDialog",
        attrs: {
          visible: _vm.syncContainerInfoDialog.visible,
          "change-post-func": _vm.syncContainerInfoChangeHandle
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.syncContainerInfoDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }